<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div *ngIf="insert_results">
      <ngb-alert [type]="'success'" [dismissible]="true" *ngIf="insert_results.valid.length > 0" class="py-1 px-2">
        <div>{{ ("VALID_FISCAL_CODES_FOR_ABSENCES_NUMBER" | translate).replace("[NUMERO]", insert_results.valid.length) }}</div>
      </ngb-alert>
      <ngb-alert [type]="'danger'" [dismissible]="true" *ngIf="insert_results.invalid.length > 0" class="py-1 px-2">
        <div>{{ ("INVALID_FISCAL_CODES_FOR_ABSENCE_NUMBER" | translate).replace("[NUMERO]", insert_results.invalid.length) }}</div>
      </ngb-alert>
    </div>
    <div class="card">
      <div class="card-title w-100 p-2 mb-0" [ngClass.sm]="'border-bottom disabled'">
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'" [ngClass.sm]="'mb-075'">
          <label class="d-flex align-items-center">
            <input type="search" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKey" [disabled]="_utilService.isMobile" />
          </label>
          <small> {{ "LAST_UPDATE" | translate }}: {{ _utilService.formatDate(_utilService.themeConfiguration.last_update_residual_absences) }} </small>
        </div>
        <div class="float-right">
          <a routerLink="/dashboard/edit-residual-absences" class="btn btn-outline-primary" [hidden]="_utilService.isMobile" *ngIf="_authenticationService.hasCapability('update_users_absences')">{{
            "UPDATE_RESIDUAL_ABSENCES" | translate
          }}</a>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body p-0" *ngIf="_utilService.isDesktop || _utilService.isTablet">
        <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [loadingIndicator]="loadingTable" [rows]="getList()" [headerHeight]="50" [rowHeight]="70" [limit]="searchKey ? 100 : 15" [footerHeight]="50">
          <ngx-datatable-column *ngFor="let key of columnKey" [name]="key.toUpperCase() | translate" [prop]="key" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row[key] || ("NOT_UPDATE" | translate) }}</ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
      <div class="card" *ngIf="_utilService.isMobile">
        <h2 class="text-center p-3">{{ "PAGE_NOT_AVAILABLE_FROM_MOBILE" | translate }}</h2>
      </div>
    </div>
  </div>
</div>
